import React from "react";
import Logo from "@/app/(general-header)/header/logo";
import LeaderboardChristmasBadge from "@/app/(general-header)/header/leaderboardChristmasBadge";

const CustomHeaderV1 = (props: any) => {
  const { IsRAFEnabled, hideBadge } = props;

  return (
    <header className={"sticky top-0 bg-white z-[1003] border-b-[#E0E0E0] border-b border-solid"}>
      <div
        className={`flex items-center justify-between h-[57px] px-3 lg:h-[78px] lg:px-6 relative mainSection mx-auto border-none`}>
        <div className="flex justify-start items-center">
          <svg
            className="size-6 lg:size-8 mr-3 cursor-pointer"
            onClick={() => history.go(-1)}
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none">
            <path
              d="M5 12H19M5 12L11 18M5 12L11 6"
              stroke="#4C4C52"
              stroke-width="1.5"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
        </div>

        <div className="relative lg:absolute lg:left-1/2 lg:top-1/2 lg:-translate-x-1/2 lg:-translate-y-1/2">
          <Logo />
        </div>
        <div className={"ml-auto flex items-center"}>
          {!hideBadge && <LeaderboardChristmasBadge IsRAFEnabled={IsRAFEnabled} />}
        </div>
      </div>
    </header>
  );
};

export default CustomHeaderV1;
